import React, { useEffect, useState } from "react";
import { ColumnsType } from "antd/es/table";
import { cellWidth } from "../../../../core/methods/tableCellWidth";
import Datatable from "../../../../core/common/dataTable";
import { useNavigate } from "react-router";
import { all_routes } from "../../../router/all_routes";
import FiltersTrackCase, {
  FiltersSelectType,
  initialFilterSelect,
  SearchFormDataType,
} from "../FiltersTrackCase";
import TimelineModal from "../TimelineModal"; 
import ModifyInviteModal from "../applicant-invited/ModifyInviteModal";
import { 
  safeLocaleCompare,
} from "../../../../core/methods/sorterMethods"; 
import useApi from "../../../../core/customhook/useApi";
import webservice_url from "../../../../core/webservice/Webservice_url";
import { formatDate } from "../../../../core/common/TabelValue";
import { getSearchableHeader } from "../../../../core/utils/getSearchableHeader";
import SnipperLoader from "../../../../core/common/loader/SnipperLoader";
import { exportAntdTableToExcel } from "../../../../core/utils/exportExcel";
import { filterByColumnSearch } from "../../../admin/utils/filterByColumnSearch";

type Props = {
  status_id: string;
};

const Insufficiency: React.FC<Props> = ({ status_id }) => {
  const navigate = useNavigate();
  const [itemList, setItemList] = useState([]);
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [searchFilter, setSearchFilter] = useState<SearchFormDataType>({
    case_id: "",
    applicant_name: "",
    email: "",
    from_date: "",
    to_date: "",
  });
  const [inventoryColumnSearch, setInventoryColumnSearch] = useState<
    Record<string, string>
  >({});
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [timelineLoading, setTimelineLoading] = useState<boolean>(false);
  const [filterData, setFilterData] =
    useState<FiltersSelectType>(initialFilterSelect);

  const [showTimeline, setShowTimeline] = useState<boolean>(false);
  const [showModifyInvite, setShowModifyInvite] = useState<boolean>(false);
 
  const filteredData = filterByColumnSearch(
    Array.isArray(itemList) ? itemList : [],
    inventoryColumnSearch,
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000,
    total: 0,
  });

  const {
    callApi: handlesSearch,
    data: dataList,
    loading: searchLoading,
  } = useApi(webservice_url.hr_reports, {
    method: "POST",
    autoCall: false,
  });

  const getCaseLog = useApi<any>(webservice_url.ViewLogAPI, {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const handleViewLog = async (caseId?: string) => {
    if (!caseId) return;
    setShowTimeline(true);
    setTimelineLoading(true);
    try {
      const res = await getCaseLog.callApi({ case_id: caseId });
      setTimelineData(res?.data ?? []);
    } catch (err) {
      console.error(err);
      setTimelineData([]);
    } finally {
      setTimelineLoading(false);
    }
  };

  const fetchData = async (
    page = pagination.current,
    pageSize = pagination.pageSize,
  ) => {
    const payload = {
      status: status_id || null,
      org_ids: filterData?.organization || null,
      project_ids: filterData?.project || null,
      program_ids: filterData?.program || null,
      department_ids: filterData?.departments || null,
      page,
      limit: pageSize,
    };

    try {
      const response = await handlesSearch(payload);
      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: response?.data?.total || 0,
      }));
    } catch (error) {
      console.error("API Failed", error);
    }
  };

  const handleTableChange = async (pagination: any) => {
    setPagination((prev) => ({
      ...prev,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize);
  }, [searchTrigger]);

  const columns: ColumnsType<any> = [
        {
      title: "Sr. No.",
      key: "serial_number",
      dataIndex: "serial_number",
      onCell: () => cellWidth(100),
      align: "center",
    },
    {
      title: getSearchableHeader(
        "Applicant Name",
        "applicant_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "applicant_name",
      onCell: () => cellWidth(200),
      render: (text: string, record: any) => (
        <div
          className="wip-link-cell"
          onClick={() => {
            navigate(all_routes.verifier_caseDetails, {
              state: {
                case_id: record.case_id,
                assignment_id: record.assignment_id,
              },
            });
          }}
        >
          {text || "-"}
        </div>
      ),
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_name"),
    },
    {
      title: getSearchableHeader(
        "Case Id",
        "case_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_id",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_id"),
    },
    {
      title: getSearchableHeader(
        "Case Spoc",
        "case_spoc",
        setInventoryColumnSearch,
      ),
      dataIndex: "case_spoc",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_spoc"),
    },
   {
      title: getSearchableHeader(
        "Case Status",
        "overall_status",
        setInventoryColumnSearch,
      ),
      dataIndex: "overall_status",
      key: "overall_status",
      onCell: () => cellWidth(200),
      sorter: (a: any, b: any) =>
        (a.overall_status ?? "").localeCompare(b.overall_status ?? ""),
      render: (text: any, record: any) => {
   
    return (
      <span
        style={{
          backgroundColor: record?.overall_color_value || "#6c757d",
          color: "#fff",
          padding: "5px 10px",
          borderRadius: "4px",
          display: "inline-block",
          fontSize: "12px",
          fontWeight: 500,
          whiteSpace: "nowrap",
        }}
      >
        {text ?? "-"}
      </span>
    );
  },
    },
    {
      title: getSearchableHeader(
        "Project",
        "project_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "project_name",
      key: "project_name",
      onCell: () => cellWidth(200),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.project_name ?? "").localeCompare(b.project_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Program",
        "program_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "program_name",
      key: "program_name",
      onCell: () => cellWidth(200),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.program_name ?? "").localeCompare(b.program_name ?? ""),
    },
    {
      title: getSearchableHeader(
        "Department",
        "department_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "department_name",
      key: "department_name",
      onCell: () => cellWidth(200),
      width: "220px",
      sorter: (a: any, b: any) =>
        (a.department_name ?? "").localeCompare(b.department_name ?? ""),
    }, 
    {
      title: getSearchableHeader(
        "Check Name",
        "check_name",
        setInventoryColumnSearch,
      ),
      dataIndex: "check_name",
      onCell: () => cellWidth(200),
      render: (text: string) => (
        <div
          style={{
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      ),
      sorter: (a, b) => safeLocaleCompare(a, b, "check_name"),
    },
    {
      title: getSearchableHeader(
        "Email Id",
        "email_id",
        setInventoryColumnSearch,
      ),
      dataIndex: "email_id", 
      width: 250,
      sorter: (a, b) => a.email_id.localeCompare(b.email_id),
    }, 
    {
      title: getSearchableHeader(
        "Raise Date",
        "raise_date",
        setInventoryColumnSearch,
      ),
      dataIndex: "raise_date",
      onCell: () => cellWidth(200),
      render: (value: string) => formatDate(value),
    },
    {
      title: getSearchableHeader(
        "Elapsed Days",
        "days_elapsed",
        setInventoryColumnSearch,
      ),
      dataIndex: "days_elapsed",
      key: "days_elapsed",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "days_elapsed"),
    },
    {
      title: "View Log",
      key: "viewLog",
     onCell: () => cellWidth(110),
      render: (_: any, record: any) => (
        <div
          className="text-center text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => handleViewLog(record.case_id)}
        >
          <i className="ti ti-eye"></i>
        </div>
      ),
    },
  ];
  useEffect(() => {
    if (dataList?.data?.rows) {
      setItemList(dataList.data.rows);
    }
  }, [dataList]);

  const handleDownloadExcel = () => {
    exportAntdTableToExcel({
      columns,
      dataSource: filteredData,
      fileName: "Insufficiency_Report",
      sheetName: "Insufficiency",
    });
  };

  const loading = searchLoading;

  return (
    <>
      {/* filters */}
      <FiltersTrackCase
        filterData={filterData}
        searchFilter={searchFilter}
        setFilterData={setFilterData}
        setSearchFilter={setSearchFilter}
        onSearch={() => setSearchTrigger((prev) => prev + 1)}
      />

      {/* Table  */}
      <div className="card mt-3">
        {searchLoading ? (
          <SnipperLoader />
        ) : (
          <>
            <div className="d-flex justify-content-end pe-2 py-2 pb-0">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={handleDownloadExcel}
                disabled={loading}
              >
                <i className="ti ti-download" /> Export to Excel
              </button>
            </div>
            <Datatable
              rowKey="sno"
              dataSource={filteredData}
              columns={columns}
              fixedHeader
              tableHeight={650}
              pagination={pagination}
              handleTableChange={handleTableChange}
            />
          </>
        )}
      </div>

      {/* Timeline */}
      {showTimeline && (
        <TimelineModal
          timelineData={timelineData}
          loading={timelineLoading}
          onClose={() => {
            setShowTimeline(false);
            setTimelineData([]);
          }}
        />
      )}
      {/* Modify Invite Modal */}
      {showModifyInvite && (
        <ModifyInviteModal
          handleClose={() => setShowModifyInvite(false)}
          handleSubmit={(d) => {
            console.log(d);
            setShowModifyInvite(false);
          }}
        />
      )}
    </>
  );
};

export default Insufficiency;
